export const CNotificationBarFragments = {
  field: `
    fragment notificationBar on notificationBar_MatrixField {
      ... on notificationBar_block_Entry {
        __typename
        notificationBarCopy
        notificationBarLink
      }
    }
  `,
}
